import moment from 'moment';
import { useApolloClient } from '@apollo/client';
import { getFoPoolstatus } from '../DataQuery';
import { Query, abortFBMatch, apiErrorCallback } from '../../../Common/graphqlFetch'

const useGetFoPools = (contentRef, setContent) => {
    // const apolloClient = useApolloClient();

    const loadfoPoolStatus = (callbackFunc) => {
        Promise.all([Query({ 
            query : getFoPoolstatus(),
            variables: {
                fbOddsTypes: ['NGS', 'NTS'],
                status: ["SELLINGSTARTED","HOLD","SELLINGSTOPPED"],
                existed: true
            }
        })])
        .then(([results]) => {
            callbackFunc(results);
        }).catch(error => apiErrorCallback(error, ()=>{loadfoPoolStatus(callbackFunc)}));
    }

    return {
        loadfoPoolStatus
    }
}

export default useGetFoPools